var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"tabs",class:_vm.wrapperClass},[_c('ul',_vm._l((_vm.tabs),function(tab,index){return _c('li',{key:index,ref:tab.value,refInFor:true,staticClass:"tabs__item",class:[
          { 'tabs__item_active' : _vm.isActive(tab) },
          tab.value === _vm.currentTab && _vm.tabActiveClass ? _vm.tabActiveClass: '',
          tab.everActive ? _vm.tabActiveClass: '',
          _vm.tabClass,

      ],attrs:{"disabled":tab.disabled || false},on:{"click":function($event){return _vm.handleClick(tab)}}},[_vm._v(" "+_vm._s(tab.title)+" "),_c('span',{staticClass:"check fas",class:[tab.checked ? 'fa-check-circle' : 'fa-exclamation-circle'],style:([tab.checked === undefined ? {'display':'none'} : {}])}),_vm._t("tabRightSlot",null,{"tab":tab,"index":index})],2)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }